<h4>
  Declaração Pessoal de Saúde: O preenchimento deve ser realizado pelo proponente
  <a href="#" onclick="return false;" class="text-secondary" data-toggle="popover" data-trigger="focus" data-content="Esta declaração será submetida à análise da Seguradora que poderá solicitar documentos complementares de saúde"><i class="fas fa-question-circle"></i></a>
</h4>

<div class="row row-cols-1 row-cols-md-2 mt-4">

  <div class="col mb-4">
    <div class="card h-100">
      <div class="card-body">
        <p>
          1- É portador (ou já foi portador) de hipertensão arterial, diabetes mellitus, doença renal, neurológica, do estômago, intestino, fígado, pâncreas, reumática, câncer (incluindo linfoma e leucemia), infectocontagiosa ou sexualmente transmissível (incluindo HIV e hepatite) ou alguma outra doença? Em caso afirmativo informe qual(is)?
        </p>
      </div>
      <div class="card-footer border-0 bg-transparent">
        <div class="text-center">
          <div class="form-check form-check-inline">
            <label class="form-check-label">
              <input class="form-check-input" type="radio" name="DCR_PERGUNTA_01" value="S" [(ngModel)]="form.DCR_PERGUNTA_01">
              Sim
            </label>
          </div>
          <div class="form-check form-check-inline">
            <label class="form-check-label">
              <input class="form-check-input" type="radio" name="DCR_PERGUNTA_01" value="N" [(ngModel)]="form.DCR_PERGUNTA_01">
              Não
            </label>
          </div>
        </div>

        @if (form.DCR_PERGUNTA_01=='S') {
          <textarea maxlength="150" class="form-control mt-2" rows="5" placeholder="Justificativa" [(ngModel)]="form.DCR_JUSTIFICATIVA_01"></textarea>
        }
      </div>
    </div>
  </div>


  <div class="col mb-4">
    <div class="card h-100">
      <div class="card-body">
        <p>
          2- É portador de alguma deficiência de órgãos, membros ou sentidos (audição, visão, etc.). Em caso afirmativo informe detalhes.
        </p>
      </div>
      <div class="card-footer border-0 bg-transparent">
        <div class="text-center">
          <div class="form-check form-check-inline">
            <label class="form-check-label">
              <input class="form-check-input" type="radio" name="DCR_PERGUNTA_02" value="S" [(ngModel)]="form.DCR_PERGUNTA_02">
              Sim
            </label>
          </div>
          <div class="form-check form-check-inline">
            <label class="form-check-label">
              <input class="form-check-input" type="radio" name="DCR_PERGUNTA_02" value="N" [(ngModel)]="form.DCR_PERGUNTA_02">
              Não
            </label>
          </div>
        </div>

        @if (form.DCR_PERGUNTA_02=='S') {
          <textarea maxlength="150" class="form-control mt-2" rows="5" placeholder="Justificativa" [(ngModel)]="form.DCR_JUSTIFICATIVA_02"></textarea>
        }
      </div>
    </div>
  </div>

  <div class="col mb-4">
    <div class="card h-100">
      <div class="card-body">
        <p>
          3- Já sofreu alguma lesão traumática com fratura, luxação, entorse ou lesão ligamentar? Em caso afirmativo informe quando aconteceu, se foi necessário o afastamento da atividade laborativa, por quanto tempo e sequelas.
        </p>
      </div>
      <div class="card-footer border-0 bg-transparent">
        <div class="text-center">
          <div class="form-check form-check-inline">
            <label class="form-check-label">
              <input class="form-check-input" type="radio" name="DCR_PERGUNTA_03" value="S" [(ngModel)]="form.DCR_PERGUNTA_03">
              Sim
            </label>
          </div>
          <div class="form-check form-check-inline">
            <label class="form-check-label">
              <input class="form-check-input" type="radio" name="DCR_PERGUNTA_03" value="N" [(ngModel)]="form.DCR_PERGUNTA_03">
              Não
            </label>
          </div>
        </div>

        @if (form.DCR_PERGUNTA_03=='S') {
          <textarea maxlength="150" class="form-control mt-2" rows="5" placeholder="Justificativa" [(ngModel)]="form.DCR_JUSTIFICATIVA_03"></textarea>
        }
      </div>
    </div>
  </div>

  <div class="col mb-4">
    <div class="card h-100">
      <div class="card-body">
        <p>
          4- Já foi submetido(a) a tratamentos quimioterápico, radioterápico, diálise, cirurgia, biópsia, punção ou internação hospitalar? Em caso afirmativo especifique qual(is), quando e o(s) motivo(s).
        </p>
      </div>
      <div class="card-footer border-0 bg-transparent">
        <div class="text-center">
          <div class="form-check form-check-inline">
            <label class="form-check-label">
              <input class="form-check-input" type="radio" name="DCR_PERGUNTA_04" value="S" [(ngModel)]="form.DCR_PERGUNTA_04">
              Sim
            </label>
          </div>
          <div class="form-check form-check-inline">
            <label class="form-check-label">
              <input class="form-check-input" type="radio" name="DCR_PERGUNTA_04" value="N" [(ngModel)]="form.DCR_PERGUNTA_04">
              Não
            </label>
          </div>
        </div>

        @if (form.DCR_PERGUNTA_04=='S') {
          <textarea maxlength="150" class="form-control mt-2" rows="5" placeholder="Justificativa" [(ngModel)]="form.DCR_JUSTIFICATIVA_04"></textarea>
        }
      </div>
    </div>
  </div>

  <div class="col mb-4">
    <div class="card h-100">
      <div class="card-body">
        <p>
          5- Já foi submetido(a) a exames como cateterismo, ecocardiograma, tomografia, ressonância magnética, endoscopia, etc.? Em caso afirmativo especifique qual(is), quando, o(s) motivo(s) e resultado(s).
        </p>
      </div>
      <div class="card-footer border-0 bg-transparent">
        <div class="text-center">
          <div class="form-check form-check-inline">
            <label class="form-check-label">
              <input class="form-check-input" type="radio" name="DCR_PERGUNTA_05" value="S" [(ngModel)]="form.DCR_PERGUNTA_05">
              Sim
            </label>
          </div>
          <div class="form-check form-check-inline">
            <label class="form-check-label">
              <input class="form-check-input" type="radio" name="DCR_PERGUNTA_05" value="N" [(ngModel)]="form.DCR_PERGUNTA_05">
              Não
            </label>
          </div>
        </div>

        @if (form.DCR_PERGUNTA_05=='S') {
          <textarea maxlength="150" class="form-control mt-2" rows="5" placeholder="Justificativa" [(ngModel)]="form.DCR_JUSTIFICATIVA_05"></textarea>
        }
      </div>
    </div>
  </div>


  <div class="col mb-4">
    <div class="card h-100">
      <div class="card-body">
        <p>
          6- Faz uso regular de algum medicamento? Em caso afirmativo informar qual(is) medicamento(s) e a dose.
        </p>
      </div>
      <div class="card-footer border-0 bg-transparent">
        <div class="text-center">
          <div class="form-check form-check-inline">
            <label class="form-check-label">
              <input class="form-check-input" type="radio" name="DCR_PERGUNTA_06" value="S" [(ngModel)]="form.DCR_PERGUNTA_06">
              Sim
            </label>
          </div>
          <div class="form-check form-check-inline">
            <label class="form-check-label">
              <input class="form-check-input" type="radio" name="DCR_PERGUNTA_06" value="N" [(ngModel)]="form.DCR_PERGUNTA_06">
              Não
            </label>
          </div>
        </div>

        @if (form.DCR_PERGUNTA_06=='S') {
          <textarea maxlength="150" class="form-control mt-2" rows="5" placeholder="Justificativa" [(ngModel)]="form.DCR_JUSTIFICATIVA_06"></textarea>
        }
      </div>
    </div>
  </div>

  <div class="col mb-4">
    <div class="card h-100">
      <div class="card-body">
        <p>
          7- Fuma ou fumou nos últimos três anos? Em caso afirmativo informar a frequência, a quantidade e o tipo (cigarro, charuto, etc.).
        </p>
      </div>
      <div class="card-footer border-0 bg-transparent">
        <div class="text-center">
          <div class="form-check form-check-inline">
            <label class="form-check-label">
              <input class="form-check-input" type="radio" name="DCR_PERGUNTA_07" value="S" [(ngModel)]="form.DCR_PERGUNTA_07">
              Sim
            </label>
          </div>
          <div class="form-check form-check-inline">
            <label class="form-check-label">
              <input class="form-check-input" type="radio" name="DCR_PERGUNTA_07" value="N" [(ngModel)]="form.DCR_PERGUNTA_07">
              Não
            </label>
          </div>
        </div>

        @if (form.DCR_PERGUNTA_07=='S') {
          <textarea maxlength="150" class="form-control mt-2" rows="5" placeholder="Justificativa" [(ngModel)]="form.DCR_JUSTIFICATIVA_07"></textarea>
        }
      </div>
    </div>
  </div>

  <div class="col mb-4">
    <div class="card h-100">
      <div class="card-body">
        <p>
          8- Consome bebidas alcoólicas mais do que 3 (três) vezes por semana? Em caso afirmativo informar o tipo de bebida, a quantidade e a frequência do consumo.
        </p>
      </div>
      <div class="card-footer border-0 bg-transparent">
        <div class="text-center">
          <div class="form-check form-check-inline">
            <label class="form-check-label">
              <input class="form-check-input" type="radio" name="DCR_PERGUNTA_08" value="S" [(ngModel)]="form.DCR_PERGUNTA_08">
              Sim
            </label>
          </div>
          <div class="form-check form-check-inline">
            <label class="form-check-label">
              <input class="form-check-input" type="radio" name="DCR_PERGUNTA_08" value="N" [(ngModel)]="form.DCR_PERGUNTA_08">
              Não
            </label>
          </div>
        </div>

        @if (form.DCR_PERGUNTA_08=='S') {
          <textarea maxlength="150" class="form-control mt-2" rows="5" placeholder="Justificativa" [(ngModel)]="form.DCR_JUSTIFICATIVA_08"></textarea>
        }
      </div>
    </div>
  </div>


  <div class="col mb-4">
    <div class="card h-100">
      <div class="card-body">
        <p>
          9- Pratica algum tipo de modalidade esportiva, em caráter profissional ou amador (ex.: mergulho, voo livre, paraquedismo) ou atividade a bordo de aeronaves? Em caso afirmativo especifique a atividade e a última vez que praticou.
        </p>
      </div>
      <div class="card-footer border-0 bg-transparent">
        <div class="text-center">
          <div class="form-check form-check-inline">
            <label class="form-check-label">
              <input class="form-check-input" type="radio" name="DCR_PERGUNTA_09" value="S" [(ngModel)]="form.DCR_PERGUNTA_09">
              Sim
            </label>
          </div>
          <div class="form-check form-check-inline">
            <label class="form-check-label">
              <input class="form-check-input" type="radio" name="DCR_PERGUNTA_09" value="N" [(ngModel)]="form.DCR_PERGUNTA_09">
              Não
            </label>
          </div>
        </div>

        @if (form.DCR_PERGUNTA_09=='S') {
          <textarea maxlength="150" class="form-control mt-2" rows="5" placeholder="Justificativa" [(ngModel)]="form.DCR_JUSTIFICATIVA_09"></textarea>
        }
      </div>
    </div>
  </div>

  <div class="col mb-4">
    <div class="card h-100">
      <div class="card-body">
        <p>
          10 - Algum membro da família (pais ou irmãos) sofre ou sofreu de alguma doença antes dos 65 anos de idade? Se sim, informe a doença, a idade do diagnóstico da doença, o parentesco e a condição.
        </p>
      </div>
      <div class="card-footer border-0 bg-transparent">
        <div class="text-center">
          <div class="form-check form-check-inline">
            <label class="form-check-label">
              <input class="form-check-input" type="radio" name="DCR_PERGUNTA_10" value="S" [(ngModel)]="form.DCR_PERGUNTA_10">
              Sim
            </label>
          </div>
          <div class="form-check form-check-inline">
            <label class="form-check-label">
              <input class="form-check-input" type="radio" name="DCR_PERGUNTA_10" value="N" [(ngModel)]="form.DCR_PERGUNTA_10">
              Não
            </label>
          </div>
        </div>

        @if (form.DCR_PERGUNTA_10=='S') {
          <textarea maxlength="150" class="form-control mt-2" rows="5" placeholder="Justificativa" [(ngModel)]="form.DCR_JUSTIFICATIVA_10"></textarea>
        }
      </div>
    </div>
  </div>

  <div class="col mb-4">
    <div class="card h-100">
      <div class="card-body">
        <p>
          11 - Possui atualmente ou está em fase de contratação de outro seguro de vida ou de acidentes pessoais? Em caso afirmativo informe a seguradora, coberturas e capital contratado.
        </p>
      </div>
      <div class="card-footer border-0 bg-transparent">
        <div class="text-center">
          <div class="form-check form-check-inline">
            <label class="form-check-label">
              <input class="form-check-input" type="radio" name="DCR_PERGUNTA_11" value="S" [(ngModel)]="form.DCR_PERGUNTA_11">
              Sim
            </label>
          </div>
          <div class="form-check form-check-inline">
            <label class="form-check-label">
              <input class="form-check-input" type="radio" name="DCR_PERGUNTA_11" value="N" [(ngModel)]="form.DCR_PERGUNTA_11">
              Não
            </label>
          </div>
        </div>

        @if (form.DCR_PERGUNTA_11=='S') {
          <textarea maxlength="150" class="form-control mt-2" rows="5" placeholder="Justificativa" [(ngModel)]="form.DCR_JUSTIFICATIVA_11"></textarea>
        }
      </div>
    </div>
  </div>

  <div class="col mb-4">
    <div class="card h-100">
      <div class="card-body">
        <p>
          12 - Alguma seguradora já recusou ou agravou algum seguro de vida ou de acidentes pessoais em seu nome? Em caso afirmativo informe se foi recusa ou agravo e o motivo.
        </p>
      </div>
      <div class="card-footer border-0 bg-transparent">
        <div class="text-center">
          <div class="form-check form-check-inline">
            <label class="form-check-label">
              <input class="form-check-input" type="radio" name="DCR_PERGUNTA_12" value="S" [(ngModel)]="form.DCR_PERGUNTA_12">
              Sim
            </label>
          </div>
          <div class="form-check form-check-inline">
            <label class="form-check-label">
              <input class="form-check-input" type="radio" name="DCR_PERGUNTA_12" value="N" [(ngModel)]="form.DCR_PERGUNTA_12">
              Não
            </label>
          </div>
        </div>

        @if (form.DCR_PERGUNTA_12=='S') {
          <textarea maxlength="150" class="form-control mt-2" rows="5" placeholder="Justificativa" [(ngModel)]="form.DCR_JUSTIFICATIVA_12"></textarea>
        }
      </div>
    </div>
  </div>

  <div class="col mb-4">
    <div class="card h-100">
      <div class="card-body">
        <p>
          13 - Fez ou faz uso de algum tipo de droga, como alucinógenos, narcóticos, cocaína, maconha, etc.? Em caso afirmativo informe tipo, quantidade, frequência e última vez que utilizou.
        </p>
      </div>
      <div class="card-footer border-0 bg-transparent">
        <div class="text-center">
          <div class="form-check form-check-inline">
            <label class="form-check-label">
              <input class="form-check-input" type="radio" name="DCR_PERGUNTA_13" value="S" [(ngModel)]="form.DCR_PERGUNTA_13">
              Sim
            </label>
          </div>
          <div class="form-check form-check-inline">
            <label class="form-check-label">
              <input class="form-check-input" type="radio" name="DCR_PERGUNTA_13" value="N" [(ngModel)]="form.DCR_PERGUNTA_13">
              Não
            </label>
          </div>
        </div>

        @if (form.DCR_PERGUNTA_13=='S') {
          <textarea maxlength="150" class="form-control mt-2" rows="5" placeholder="Justificativa" [(ngModel)]="form.DCR_JUSTIFICATIVA_13"></textarea>
        }
      </div>
    </div>
  </div>

  <div class="col mb-4">
    <div class="card h-100">
      <div class="card-body">
        <p>
          14 - Sofreu alguma alteração de peso (perda ou ganho) de mais de 10kgs nos últimos 6 meses? Em caso afirmativo informe se houve perda ou ganho, a alteração em kg e especifique o motivo.
        </p>
      </div>
      <div class="card-footer border-0 bg-transparent">
        <div class="text-center">
          <div class="form-check form-check-inline">
            <label class="form-check-label">
              <input class="form-check-input" type="radio" name="DCR_PERGUNTA_14" value="S" [(ngModel)]="form.DCR_PERGUNTA_14">
              Sim
            </label>
          </div>
          <div class="form-check form-check-inline">
            <label class="form-check-label">
              <input class="form-check-input" type="radio" name="DCR_PERGUNTA_14" value="N" [(ngModel)]="form.DCR_PERGUNTA_14">
              Não
            </label>
          </div>
        </div>

        @if (form.DCR_PERGUNTA_14=='S') {
          <textarea maxlength="150" class="form-control mt-2" rows="5" placeholder="Justificativa" [(ngModel)]="form.DCR_JUSTIFICATIVA_14"></textarea>
        }
      </div>
    </div>
  </div>


  <div class="col mb-4">

    <div class="row">
      <div class="col">
        <div class="card h-100">
          <div class="card-body">
            <div class="form-group row">
              <label for="altura" class="col-sm-3 col-form-label">15- Altura(m):</label>
              <div class="col-sm-09">
                <input type="text" class="form-control" id="altura" name="altura"
                  mask="separator.2"
                  thousandSeparator="."
                  decimalMarker=","
                  [dropSpecialCharacters]="true"
                  [(ngModel)]="form.VLR_PERGUNTA_15"
                  >
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col">
          <div class="card h-100">
            <div class="card-body">
              <div class="form-group row">
                <label for="peso" class="col-sm-3 col-form-label">16- Peso(Kg):</label>
                <div class="col-sm-09">
                  <input type="text" class="form-control" id="peso" name="peso"
                    mask="separator.3"
                    thousandSeparator="."
                    decimalMarker=","
                    [dropSpecialCharacters]="true"
                    [(ngModel)]="form.VLR_PERGUNTA_16">
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>


      @if (idcAposentado=='S') {
        <div class="col mb-4">
          <div class="card h-100">
            <div class="card-body">
              <p>
                17 - Motivo Aposentadoria:
              </p>
              <div class="row mt-2">
                <div class="col-sm-10">
                  <div class="form-check">
                    <input class="form-check-input" type="radio" name="motivoApos" id="motivoApos1" value="Tempo de Serviço" [(ngModel)]="form.DCR_PERGUNTA_17">
                    <label class="form-check-label" for="motivoApos1">
                      Tempo de Serviço
                    </label>
                  </div>
                  <div class="form-check">
                    <input class="form-check-input" type="radio" name="motivoApos" id="motivoApos2" value="Idade" [(ngModel)]="form.DCR_PERGUNTA_17">
                    <label class="form-check-label" for="motivoApos2">
                      Idade
                    </label>
                  </div>
                  <div class="form-check disabled">
                    <input class="form-check-input" type="radio" name="motivoApos" id="motivoApos3" value="Invalidez" [(ngModel)]="form.DCR_PERGUNTA_17">
                    <label class="form-check-label" for="motivoApos3">
                      Invalidez
                    </label>
                  </div>
                </div>
              </div>
              @if (form.DCR_PERGUNTA_17=='Invalidez') {
                <textarea maxlength="60" class="form-control mt-2" rows="5" placeholder="Causa da aposentadoria por invalidez:" [(ngModel)]="form.DCR_JUSTIFICATIVA_17"></textarea>
              }
            </div>
          </div>
        </div>
      }

    </div>


    <div class="mt-3 row justify-content-between">
      <div class="col text-left">
        <button type="button" class="btn btn-primary" (click)="voltar()">
          <i class="fas fa-chevron-left"></i>
          Voltar
        </button>
      </div>
      <div class="col text-right">
        <button type="button" class="btn btn-success" (click)="proximo()" [disabled]="loading">
          Próximo
          <i class="fas fa-chevron-right"></i>
        </button>
      </div>
    </div>